class IngredientFeature {
  constructor(section) {
    this.section = section;
    this.triggers = [...section.querySelectorAll('[data-ingredient-trigger]')];
    this.accordions = [...section.querySelectorAll('[data-ingredient-accordion]')];

    this.bindDesktop();
    this.bindMobile();
  }

  bindDesktop() {
    this.triggers.forEach((trigger) => {
      trigger.addEventListener('mouseenter', () => this.activateDesktop(trigger));
      trigger.addEventListener('focus', () => this.activateDesktop(trigger));
      trigger.addEventListener('click', () => this.activateDesktop(trigger));
    });
  }

  activateDesktop(activeTrigger) {
    this.triggers.forEach((trigger) => {
      trigger.classList.toggle('is-active', trigger === activeTrigger);
    });
  }

  bindMobile() {
    this.accordions.forEach((accordion) => {
      accordion.addEventListener('click', () => {
        const isActive = accordion.classList.contains('is-active');

        this.accordions.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-expanded', 'false');
        });

        if (!isActive) {
          accordion.classList.add('is-active');
          accordion.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }
}

function initIngredientFeatures() {
  document.querySelectorAll('[data-ingredient-feature]').forEach((section) => {
    if (section.dataset.ingredientFeatureInit === 'true') return;

    section.dataset.ingredientFeatureInit = 'true';
    new IngredientFeature(section);
  });
}

document.addEventListener('DOMContentLoaded', initIngredientFeatures);
document.addEventListener('shopify:section:load', initIngredientFeatures);